import type { QuestionnaireResponse, Resource } from "@medplum/fhirtypes";
import { extensionUrl } from "@repo/fhir-systems";

/** Patient questionnaires use a profile. PerfO administrations use a distinct tag and no questionnaire profile. */

/** What marks a row as a questionnaire instance rather than a performance measure. */
export const QUESTIONNAIRE_INSTANCE_PROFILE = extensionUrl("questionnaire-instance");

/** The profile as read off a loaded row; false for a row of the other kind or none. */
export function hasResponseProfile(resource: Resource, profile: string): boolean {
  return (resource as QuestionnaireResponse).meta?.profile?.includes(profile) === true;
}
